const ProblemSection = () => {
  return (
    <section className="py-32 px-4 bg-secondary border-y-4 border-foreground">
      <div className="container mx-auto max-w-4xl space-y-8">
        <div className="inline-block px-6 py-3 bg-accent/10 border-2 border-accent/20 rounded">
          <span className="text-sm font-bold tracking-[0.3em] text-accent uppercase">The Problem</span>
        </div>
        <h2 className="text-4xl md:text-6xl font-black leading-tight text-foreground">
          Most AI startups don't die from bad tech. They die in procurement.
        </h2>
        <p className="text-xl text-foreground leading-relaxed border-l-4 border-accent pl-6">
          You can build the best product in your category and still lose 9 months to security reviews,
          unmetered pilot debates, and a CFO who can't see the ROI. Enterprise buyers don't buy features.
          They buy risk reduction, clear ROI, and internal alignment. Most venture capital firms can't help
          you there. AMX Ventures can, because we've sat in those rooms for 21 years.
        </p>
      </div>
    </section>
  );
};

export default ProblemSection;